import { appUrl } from 'utils/wrappers';
import { showSuccess, showResponseError } from 'utils/messages';
import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('bank_accounts'),
  rootKey: 'bank_account',

  verify(amounts) {
    const self = this;
    const url = `${this.url()}/verify`;
    this.sync('create', this, {
      url,
      attrs: { amounts },
      success(_, status, response) {
        showSuccess('Bank account verified successfully');
        self.set(self.parse(JSON.parse(response.responseText)), {});
      },
      error(res) {
        showResponseError(res);
      },
    });
  },

  charge(amount, user) {
    const url = `${this.url()}/charges`;
    const self = this;
    this.sync('create', this, {
      url,
      attrs: { amount },
      success() {
        showSuccess('Transfer initiated successfully');
        self.trigger('charge');
        user.fetch({ reset: true });
      },
      error(res) {
        showResponseError(res);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/models/bank_account.js